<template>
  <div class="a-gallery-location">
    <div v-if="locations && locations.length">
      {{ onViewMessage }}
      <DelimitedFieldValues
        v-if="locations"
        ref="location-link"
        class="a-gallery-location__link"
        :data-testid="'location-link'"
        :values="locations"
        :delimiter="locations.length > 2 ? ', ' : ''"
      />
    </div>
    <p
      v-else
      ref="location-message"
      data-testid="location-message"
      class="a-gallery-location__message"
    >
      {{ onViewMessage }}
    </p>
  </div>
</template>
<script>
import { DelimitedFieldValues } from "@thegetty-private/getty-ui";
import { useLocalization } from "@thegetty-private/getty-ui";

export default {
  name: "GalleryLocation",
  components: { DelimitedFieldValues },

  props: {
    /**
     * The HumanMadeObject JSON-LD
     */
    humanMadeObject: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  computed: {
    /**
     * Gets the location message and route info
     *
     * @returns {array} - list of locations with routes
     */
    locations() {
      let locations =
        this.humanMadeObject?.objectProfile?.currentLocations || [];
      if (locations && locations.length > 1) {
        locations.at(-1).beforeLink = this.translatePart("object_page.and");
      }
      return locations;
    },
    /**
     * Gets the on view message
     *
     * @returns {string}
     */
    onViewMessage() {
      if (!this.locations || this.locations.length == 0) {
        return this.translatePart("object_page.not_on_view");
      }
      return this.translatePart("object_page.on_view");
    }
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
